import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Palette, Factory, BoxIcon } from 'lucide-react';
const features = [{
  icon: Zap,
  title: 'Fast Turnaround',
  description: 'Standard 3-5 day production. Rush options available for tight deadlines.'
}, {
  icon: Factory,
  title: 'Commercial Equipment',
  description: 'Top-of-the-line M&R presses and industrial DTF printers. No hobby gear.'
}, {
  icon: BoxIcon,
  title: 'Bulk & Wholesale',
  description: 'Optimized for high-volume orders. The more you print, the less you pay.'
}, {
  icon: Palette,
  title: 'Color Accuracy',
  description: 'Pantone matching systems ensuring your brand colors hit the mark every time.'
}, {
  icon: ShieldCheck,
  title: 'Real Production',
  description: 'We are not a broker. We own the machines, we print the shirts, we control the quality.'
}];
export function WhyPrintAtomic() {
  return <section className="py-24 bg-atomic-black border-y border-white/5" data-id="element-193">
      <div className="container mx-auto px-4 md:px-6" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-196">
            Why Print Atomic?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-197">
            We've stripped away the fluff to focus on what matters: speed,
            quality, and reliability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-198">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-atomic-charcoal p-8 rounded-xl border border-white/5 hover:border-atomic-green/30 transition-colors" data-id="element-199">
              <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-atomic-dark text-atomic-green border border-white/10" data-id="element-200">
                <feature.icon size={24} data-id="element-201" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-202">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-203">
                {feature.description}
              </p>
            </motion.div>)}

          {/* Callout Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="bg-gradient-to-br from-atomic-green to-lime-500 p-8 rounded-xl flex flex-col justify-center items-center text-center border border-lime-400/30" data-id="element-204">
            <h3 className="text-2xl font-bold text-black mb-2" data-id="element-205">
              Ready to scale?
            </h3>
            <p className="text-black/80 mb-6" data-id="element-206">
              Get a custom quote for your next project.
            </p>
            <button className="bg-black text-atomic-green px-6 py-2 rounded-md font-bold hover:bg-atomic-charcoal transition-colors w-full" data-id="element-207">
              Get Started
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}